import { Container } from 'inversify'
import { rootContainer } from '~/container'
import { ErrorPlatformEvent, interpret } from '~/node_modules/xstate-v4'
import sentryCapture from '~/utility/sentryCapture'
import { returnSignUpMachine } from './machine'
import { UserSignupRepository } from './repositories'
import { UserSignupRepositoryFetch } from './UserSignupRepositoryFetch'

const signUpContainer = new Container()
signUpContainer.parent = rootContainer
signUpContainer.bind(UserSignupRepository).to(UserSignupRepositoryFetch)

export function getSignUpMachine(langCode: string) {
  return interpret(
    returnSignUpMachine().withConfig({
      services: {
        createUser: (_, event: any) =>
          signUpContainer
            .get(UserSignupRepository)
            .signup(event.data, langCode),
      },
      actions: {
        logError: (_, _event: any) => {
          const event: ErrorPlatformEvent = _event
          event.data.name = `SignUpMachine ${event.type} error`
          sentryCapture(event.data, rootContainer)
        },
      },
    }),
  )
}
